import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.showTabFromHash()
    window.addEventListener('hashchange', this.showTabFromHash)
  }

  disconnect() {
    window.removeEventListener('hashchange', this.showTabFromHash)
  }

  showTabFromHash = () => {
    const hash = window.location.hash
    if (!hash) return

    const button = this.element.querySelector(`[data-bs-target="${hash}"]`)
    if (button) {
      const tabTrigger = new bootstrap.Tab(button)
      tabTrigger.show()
    }
  }
}
